import React, { useState, useEffect } from 'react';
import { Card, Row, Col, Form, Button, Table, Modal } from 'react-bootstrap';
import { MdAddCircle } from 'react-icons/md';
import { FiMinusCircle } from "react-icons/fi";
import { Link, useNavigate } from 'react-router-dom';
import Select from 'react-select';
import { RiDeleteBin6Fill } from "react-icons/ri";
import axios from 'axios';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Swal from 'sweetalert2';
import 'sweetalert2/src/sweetalert2.scss';
import { FaEdit } from "react-icons/fa";
import { MdDelete } from "react-icons/md";
import { FaArrowLeftLong, FaPlus } from "react-icons/fa6";

import Addproduct from '../commanpage/Addproduct';
import { FaEye } from "react-icons/fa";

import AddproductRaw from '../commanpage/AddrowmaterialOrder';
import { FaArrowAltCircleRight } from "react-icons/fa";
import { v4 as uuidv4 } from 'uuid';
import { RiDeleteBin6Line } from "react-icons/ri";
export default function Takeorder() {
    const [errors, setErrors] = useState({});
    const token = localStorage.getItem('token');
    const order_Update_id = localStorage.getItem('order_Update_id');
    const orderid = localStorage.getItem('up_orderid');
    const [loading, setLoading] = useState(false);
    const [categories, setCategories] = useState([]);
    const [components, setComponents] = useState([]);
    const [extra_categories, setCategoriesExtra] = useState([]);
    const [productdata, setproduct] = useState([]);
    const [viewdata, setViewdata] = useState([]);
    const [accountlist, setAccountList] = useState([]);
    const [account_mode, setAccountMode] = useState('');
    const [EnterQty, setEnterQty] = useState();
    const [EnterProQty, setEnterProQty] = useState();
    const [TotalQtyPrice, setTotalQtyPrice] = useState();
    const [CalculatedDueAmt, setCalculatedDueAmt] = useState();
    // console.warn(accountlist);
    const [venderlist, setVenderlist] = useState([]);
    const [data, setViewData] = useState([]);
    const [AreaCount, setAreaCount] = useState([]);
    const [filteredComponents, setFilteredComponents] = useState([]);
    // console.warn(data)

    const [productorderdata, setproductorder] = useState([]);
    const [productorderID, setproductorderID] = useState([]);
    const [show, setShow] = useState(false);
    // const [rows, setRows] = useState([{ category_id: null, product_id: null, vendor_id: null, qty: '', price: '', id: '', order_id: '', qty_old: '' }]);
    const [rowother, setRowother] = useState([{ tr_charge: null, lable_charge: null, name: '', id: '' }]);
    const [modalState, setModalState] = useState({ addproduct: false, addraw: false });
    const handleCloseEditModal = () => setShowEditModal(false);
    const handleShowEditModal = () => setShowEditModal(true);
    const [showEditModal, setShowEditModal] = useState(false);
    const [searchNameList, setSearchNameList] = useState([]);
    const [filteredNameList, setFilteredNameList] = useState([]);
    const [selectedOrderType, setSelectedOrderType] = useState([0]);
    const [customers, setCustomers] = useState([]);
    const [Totalamountnew, setTotalamount] = useState();
    const [Dueamountold, setDueamount] = useState();
    const [TotalcustomerDataamount, setTotalcustomerDataamount] = useState();
    const [EnterQtyStockId, setEnterQtyStockId] = useState();
    const [EnterQtyStockName, setEnterQtyStockName] = useState();
    const [EnterQtyStockproqty, setEnterQtyStockpro_qty] = useState();

    const [vendors, setVendors] = useState([]);
    const [rows1, setRows1] = useState([{
        vendor_id: null,
        category_id: null,
        customer_id: null,
        name: '',
        pro_qty: '',
        price: '',
        total_amount: ''
    }]);

    const [rows, setRows] = useState([
        {
            category_id: null,
            product_id: null,
            area_id: null,
            component_order: [
                {
                    area_description: '',
                    cost_price: 0,
                    sale_price: 0,
                    sub_component_order: [
                        { component_id: null, vender_id: null }
                    ]
                }
            ]
        }
    ]);
    const [fields, setFields] = useState(() => ('fields', [{
        category_id: null, area: null, area_description: '', sale_price: '', cost_price: ''
    }]));

    const [fields1, setFields1] = useState(() => ('fields1', [{
        vendor_id: null, component_id: null, category_id: null, product_id: null
    }]));

    const handleComponentSelection = (rowIndex, fieldIndex, subIndex, selected) => {
        const updatedRows = [...rows];
        const updatedComponentOrder = [...updatedRows[rowIndex].component_order];
        const updatedSubComponentOrder = [...updatedComponentOrder[fieldIndex].sub_component_order];

        updatedSubComponentOrder[subIndex] = {
            ...updatedSubComponentOrder[subIndex],
            component_id: selected ? selected.value : null,
        };

        updatedComponentOrder[fieldIndex] = {
            ...updatedComponentOrder[fieldIndex],
            sub_component_order: updatedSubComponentOrder,
        };

        updatedRows[rowIndex] = {
            ...updatedRows[rowIndex],
            component_order: updatedComponentOrder,
        };

        setRows(updatedRows); // Update state
    };

    const handleVendorSelection = (rowIndex, fieldIndex, subIndex, selected) => {
        const updatedRows = [...rows];
        const updatedComponentOrder = [...updatedRows[rowIndex].component_order];
        const updatedSubComponentOrder = [...updatedComponentOrder[fieldIndex].sub_component_order];

        updatedSubComponentOrder[subIndex] = {
            ...updatedSubComponentOrder[subIndex],
            vender_id: selected ? selected.value : null,
        };

        updatedComponentOrder[fieldIndex] = {
            ...updatedComponentOrder[fieldIndex],
            sub_component_order: updatedSubComponentOrder,
        };

        updatedRows[rowIndex] = {
            ...updatedRows[rowIndex],
            component_order: updatedComponentOrder,
        };

        setRows(updatedRows); // Update state
     
    };

    // const handleDeleteExtraField = (rowIndex, fieldIndex, extraFieldIndex) => {
    //     const updatedRows = [...rows];
    //     updatedRows[rowIndex].fields[fieldIndex].extraFields.splice(extraFieldIndex, 1);
    //     setRows(updatedRows);
    // };

    const handleDeleteExtraField = (rowIndex, fieldIndex, extraFieldIndex) => {
        const updatedRows = [...rows];

        // Ensure correct access to the nested structure based on your data
        updatedRows[rowIndex].component_order[fieldIndex].sub_component_order.splice(extraFieldIndex, 1);

        setRows(updatedRows);
    };

    const handleAddMoreComponentVendor = (rowIndex, fieldIndex) => {
        const updatedRows = [...rows];
        updatedRows[rowIndex].component_order[fieldIndex].sub_component_order.push({
            component_id: null,
            vender_id: null,
        });
        setRows(updatedRows);
    };

    const customerOptions = customers.map(item => ({ value: item.id, label: item.customer_name }));
    const vendorOptions1 = vendors.map(item => ({ value: item.id, label: item.vendor_name }));
    const handleAddRow1 = () => {
        setRows1([...rows1, { vendor_id: null, category_id: null, customer_id: null, name: '', pro_qty: '', price: '', total_amount: '' }]);
    };

    const handleDeleteRow1 = index => {
        setRows1(rows1.filter((_, i) => i !== index));
    };


    useEffect(() => {
        const fetchData = async () => {
            try {
                const [categoriesRes, componentsRes, customersRes, vendorsRes] = await Promise.all([
                    axios.get(`${process.env.REACT_APP_API_URL}category-list`, { headers: { 'x-access-token': token } }),
                    axios.get(`${process.env.REACT_APP_API_URL}component-list`, { headers: { 'x-access-token': token } }),
                    axios.get(`${process.env.REACT_APP_API_URL}Custumer-name-list`, { headers: { 'x-access-token': token } }),
                    axios.get(`${process.env.REACT_APP_API_URL}Vender-list`, { headers: { 'x-access-token': token } })
                ]);

                setCategories(categoriesRes.data.data || []);
                setComponents(componentsRes.data.data || []);
                setCategoriesExtra(categoriesRes.data.data || []);
                setCustomers(customersRes.data.data || []);
                setVendors(vendorsRes.data.data || []);
            } catch (error) {
                // toast.error('Failed to fetch data.');
            }
        };

        fetchData();
    }, [token]);



    const handleOrderTypeChange = (selectedOption) => {
        setSelectedOrderType(selectedOption);
    };
    const [currentEditId, setCurrentEditId] = useState(null);
    const [formData, setFormData] = useState({
        order_date: new Date().toISOString().split('T')[0], customer_type: "", customer_name: "", mobile_number: "", invoice_number_manual: '', vehicle_number: '', gst_in_no: '', c_gst: '', s_gst: '', description: '', email: "", site_name: "", address1: "", address2: "", city: "", state: "", pincode: "", manufacture: "Trading", amount: "", receiver_name: "", payer_name: "", delivery_date: "", due_amt: "",
    });

    const handleAddRow = () => {
        const newRow = {
            category_id: null,
            product_id: null,
            area_id: 0,
            component_order: [],
        };
        
        toast.success("New Area added successfully!");
        setRows((prevRows) => [...prevRows, newRow]);

    };

    const validateComponentAndVendorSelection = (row) => {
        // Check if at least one component and vendor are selected
        return row.component_order.some(field => {
            return field.sub_component_order.some(subField => {
                return subField.component_id && subField.vender_id; // Check both component and vendor
            });
        });
    };

    const handleCheckButtonClicknew = (index) => {
        const updatedRows = [...rows];
        if (updatedRows[index].component_order.length > 0) {
            const firstFieldExtraFields = updatedRows[index].component_order[0]?.sub_component_order || [];
            updatedRows[index].component_order = updatedRows[index].component_order.map((field, i) => {

                const newExtraFields = firstFieldExtraFields.map(extra => ({
                    // id: extra.id,  
                    component_id: extra.component_id,
                    category_id: extra.category_id,
                    vender_id: extra.vender_id,
                    area_description_id: extra.area_description_id
                }));
                return {
                    ...field,
                    sub_component_order: newExtraFields
                };
            });
        }
        setRows(updatedRows);
        console.log("showwwrowsssss", updatedRows);
        
    };
    // const handleCheckButtonClick = (index) => {
    //     setRows((prevRows) => {
    //         const updatedRows = prevRows.map((row, rowIndex) => {
    //             if (rowIndex !== index) return row;  // Keep other rows unchanged
    
    //             if (row.component_order.length > 0) {
    //                 // Get the sub_component_order from the first component_order (component_order[0])
    //                 const firstFieldSubComponents = row.component_order[0]?.sub_component_order || [];
    //                 const vendor_id = firstFieldSubComponents[firstFieldSubComponents.length - 1]?.vender_id;
    //                 const component_id = firstFieldSubComponents[firstFieldSubComponents.length - 1]?.component_id;
    
    //                 return {
    //                     ...row,
    //                     component_order: row.component_order.map((field, i) => {
    //                         // Check if it's the second component_order (index 1)
    //                         if (i === 1) {
    //                             const secondSubComponents = field.sub_component_order || [];
                                
    //                             // If the first component has more sub_components than the second
    //                             if (firstFieldSubComponents.length > secondSubComponents.length) {
    //                                 // Calculate how many new entries we need to add
    //                                 const diff = firstFieldSubComponents.length - secondSubComponents.length;
    //                                 const newSubComponents = Array.from({ length: diff }, () => ({
    //                                     component_id: component_id,
    //                                     vender_id: vendor_id,
                                        
    //                                 }));
    
    //                                 return {
    //                                     ...field,
    //                                     sub_component_order: [...secondSubComponents, ...newSubComponents]
    //                                 };
    //                             }
    //                         }
    
    //                         return field; 
    //                     })
    //                 };
    //             }
    
    //             return row;  
    //         });
    
    //         console.log("updatedRows", updatedRows);
    //         return updatedRows;
    //     });
    // };
  
    
    
    
    
    

    /// equal vendor and component
    const handleCheckButtonClickold = (index) => {
        setRows((prevRows) => {
            const updatedRows = prevRows.map((row, rowIndex) => {
                if (rowIndex !== index) return row;  // Keep other rows unchanged
    
                if (row.component_order.length > 0) {
                    // Get the sub_component_order from the first component_order (component_order[0])
                    const firstFieldSubComponents = row.component_order[0]?.sub_component_order || [];
    
                    return {
                        ...row,
                        component_order: row.component_order.map((field) => {
                            return {
                                ...field,
                                sub_component_order: field.sub_component_order.map((subComponent, subIndex) => {
                                    // Copy each sub_component_order and assign new vendor_id and component_id
                                    return {
                                        ...subComponent,
                                        vender_id: firstFieldSubComponents[subIndex]?.vender_id, // Assign vendor_id from first sub_component
                                        component_id: firstFieldSubComponents[subIndex]?.component_id // Assign component_id from first sub_component
                                    };
                                })
                            };
                        })
                    };
                }
    
                return row; // Return unchanged row if no component_order
            });
    
            console.log("updatedRows", updatedRows);
            return updatedRows;
        });
    };
    

    
    console.log("showwwrowsssss", rows);

    const handleAddSubRow = (rowIndex) => {
        const updatedRows = [...rows];
        const newSubRow = {
            area_description: "",
            cost_price: 0,
            sale_price: 0,
            sub_component_order: []
        };
        updatedRows[rowIndex].component_order.push(newSubRow);
        setRows(updatedRows);
    };

    const handleAddRowOther = () => { setRowother([...rowother, { tr_charge: null, lable_charge: null, name: '' }]); };
    const navigate = useNavigate();
    const categoryOptions = categories.map((item) => ({ value: item.id, label: item.name, }));
    const componentOptions = components.map((item) => ({
        value: item.id,
        label: item.name,
        category_Id: item.category_Id,
    }));
    const extra_categoryOptions = extra_categories.map((item) => ({ value: item.id, label: item.name, }));
    const vendorOptions = venderlist.map((item) => ({ value: item.id, label: item.vendor_name, }));
    // console.warn("productorderdata", vendorOptions);
    // console.warn("componentOptions", componentOptions);
    const getProductOptionsForRow = (category_id, manufacture) => {
        return productorderdata.filter(item => item.category_id == category_id && item.manufacture == manufacture)
            .map(item => ({
                value: item.id,
                label: item.name,
                sale_price: item.sale_man_amount,
                cost_price: item.man_amount
            }));
    };
    console.log("productorderdataaaaaaa", productorderdata);
    const handleInputChange = (e) => {
        const { name, value } = e.target;

        // Validation for mobile number
        if (name === 'mobile_number') {
            // Allow only digits and limit the length to 10
            const formattedValue = value.replace(/\D/g, '').slice(0, 10);
            setFormData({ ...formData, [name]: formattedValue });

            // If the length is not 10, set an error
            if (formattedValue.length !== 10) {
                setErrors((prevErrors) => ({ ...prevErrors, [name]: 'Mobile number must be 10 digits long' }));
            } else {
                setErrors((prevErrors) => ({ ...prevErrors, [name]: false }));
            }
        } else {
            setFormData({ ...formData, [name]: value });
            setErrors((prevErrors) => ({ ...prevErrors, [name]: false }));
        }
        if (name === 'customer_name') {
            if (value.trim() !== '') {
                filterSearchName(value);

            } else {
                setSearchNameList([]);
            }
        }
    };


    // const handleSelectChange = (name, selectedOption) => {
    //     if (name === 'account_id' && selectedOption) {
    //         setAccountMode(selectedOption.account_type || '');
    //         setFormData({
    //             ...formData,
    //             [name]: selectedOption ? selectedOption.value : null,
    //             account_mode: selectedOption.account_type || '',
    //         });
    //     }
    //     else if (name === 'product_id') {
    //         const selectedProduct = selectedOption ? { id: selectedOption.value, name: selectedOption.label } : null;
    //         setFormData({ ...formData, [name]: selectedProduct });
    //     } else {
    //         setFormData({ ...formData, [name]: selectedOption });
    //     }
    // };

    const handleSelectChange = (name, selectedOption) => {
        if (name === 'account_id' && selectedOption) {
            // Set account mode based on the selected account
            const accountMode = selectedOption.account_type || ''; // Assuming account_type is the mode
            setAccountMode(accountMode);  // Update account_mode state
            console.log("accountMode", accountMode);
            // Update formData with selected account id and account mode
            setFormData({
                ...formData,
                [name]: selectedOption ? selectedOption.value : null,
                account_mode: accountMode,
            });
        }
        // Handle other fields (like product_id) if needed
        else if (name === 'product_id' && selectedOption) {
            const selectedProduct = selectedOption ? { id: selectedOption.value, name: selectedOption.label } : null;
            setFormData({ ...formData, [name]: selectedProduct });
        }
        // For other fields, just update the formData
        else {
            setFormData({ ...formData, [name]: selectedOption ? selectedOption.value : null });
        }
    };



    const handleRowChange = (indexOrValue, field, value) => {
        // Check if indexOrValue is a number (row index) or a string (area value)
        if (typeof indexOrValue === 'number') {
            // Handle row change logic
            const index = indexOrValue;
            const updatedRows = [...rows];
            updatedRows[index][field] = value;

            if (field === 'pro_qty' || field === 'price') {
                updatedRows[index].total_amount = (updatedRows[index].pro_qty * updatedRows[index].price).toFixed(2);
            }

            setRows(updatedRows);

            if (updatedRows.length > 0) {
                const { qty, pro_qty, price } = updatedRows[0];
                setEnterQty(qty);
                setEnterProQty(pro_qty);
                setTotalQtyPrice(qty * price);
                console.warn("Qty:", qty, "Pro Qty:", updatedRows, price, qty * price);
            }

            if (field === "category_id") {
                // Filter components based on selected category_id
                const filtered = componentOptions.filter(component => component.category_Id === value);
                setFilteredComponents(filtered);

                console.log("filtered", filtered);
            }
        } else {
            // Handle area change logic
            const areaCount = parseInt(indexOrValue, 10);

            if (isNaN(areaCount) || areaCount <= 0) {
                // Clear all rows if the input is empty or invalid
                setFields([]);
            } else {
                // Generate rows based on the valid input
                setFields(
                    Array.from({ length: areaCount }, (_, i) => ({
                        id: i,
                        description: "",
                        cost_price: "",
                        sale_price: "",
                        extraFields: [],
                    }))
                );
            }
        }
    };

    const handleRowChangeOther = (index, field, value) => {
        const updatedRows = [...rowother];
        updatedRows[index][field] = value;
        setRowother(updatedRows);
    };
    const handleRowChangeExtra = (index, field, value) => {
        const updatedRows = [...rows1];
        updatedRows[index][field] = value;
        if (field === 'pro_qty' || field === 'price') {
            updatedRows[index].total_amount = (updatedRows[index].pro_qty * updatedRows[index].price).toFixed(2);
        }
        setRows1(updatedRows);
    };
    const validateForm = () => {
        const newErrors = {};

        // Check for required fields
        Object.keys(formData).forEach((key) => {
            if (!formData[key] && key !== 'email' && key !== 'site_name' && key !== 'pincode' && key !== 'address2' && key !== 'qty' && key !== 'customer_type' && key !== 'city' && key !== 'state' && key !== 'address1' && key !== 'description' && key !== 'invoice_number_manual' && key !== 'vehicle_number' && key !== 'gst_in_no' && key !== 'c_gst' && key !== 's_gst') {
                newErrors[key] = 'This field is required';
            }
        });

        // Validate quantity against available stock
        rows.forEach((row, index) => {
            const product = productorderdata.find(item => item.id === row.product_id?.id);
            if (product && parseInt(row.qty) > parseInt(product.pro_qty)) {
                newErrors[`qty_${index}`] = `Quantity exceeds available stock (${product.pro_qty})`;
            }
        });

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };


    const handleSubmit = async (url, formData, rows, successCallback) => {
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: 'Do you want to submit the form?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, submit it!',
            cancelButtonText: 'No, cancel!',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
        });

        // If the user confirms, proceed with the submission
        if (result.isConfirmed) {
            setLoading(true);
            try {
                const { product_id, ...requestData } = formData;

                // handlePaymentSubmit();
                // handleSubmitStockOrder();
                const payload = {
                    ...requestData,
                    // products: productsData,
                };

                const response = await axios.post(url, payload, {
                    headers: {
                        'Content-Type': 'application/json',
                        'x-access-token': token,
                    },
                });

                if (response.data.status === 1) {


                    Swal.fire({
                        title: 'Success',
                        text: response.data.message,
                        icon: 'success',
                        timer: 3000,
                        showConfirmButton: false,
                    });
                    setFormData({
                        order_date: new Date().toISOString().split('T')[0], customer_type: "", customer_name: "", mobile_number: "", invoice_number_manual: '', vehicle_number: '', gst_in_no: '', c_gst: '', s_gst: '', description: '', email: "", site_name: "", address1: "", address2: "", city: "", state: "", pincode: "", amount: "", receiver_name: "", payer_name: "", delivery_date: "",
                    });
                    setFields([]);
                    setRows([]);
                    setRowother([]);
                    setTimeout(() => {
                        successCallback && successCallback(response.data.payload);
                        navigate('/orderview')
                    }, 1000);
                } else {
                    Swal.fire({
                        title: 'Error',
                        text: response.data.message,
                        icon: 'error',
                    });
                }
            } catch (error) {
                Swal.fire({
                    title: 'Error',
                    text: 'An error occurred',
                    icon: 'error',
                });
            } finally {
                setLoading(false);
            }
        } else {
            // User canceled the action
            Swal.fire('Cancelled', 'Your submission has been cancelled.', 'info');
        }
    };

    let total_pricesalePrice = Array.isArray(rows)
        ? rows.reduce((accumulator, row) => {
            const rowTotal = Array.isArray(row.component_order)
                ? row.component_order.reduce((fieldAccumulator, field) => {
                    const salePrice = parseFloat(field.sale_price) || 0;
                    return fieldAccumulator + salePrice;
                }, 0)
                : 0;
            return accumulator + rowTotal;
        }, 0)
        : 0;

    const extra_charges_total = rows1.reduce((total, row) => {
        const charge = parseFloat(row.total_amount) || 0;
        return total + charge;
    }, 0).toFixed(2);

    const total_price_without_gst = rows.reduce((total, row) => {
        const priceWithoutGst = parseFloat(row.price) || 0;
        const qty = parseFloat(row.qty) || 0;
        return total + (qty * priceWithoutGst);
    }, 0).toFixed(2);
    const total_price = (total_pricesalePrice + parseFloat(total_price_without_gst) + parseFloat(extra_charges_total));


    const other_charges_total = rowother.reduce((total, row) => {
        const charge = parseFloat(row.lable_charge) || 0;
        return total + charge;
    }, 0).toFixed(2);
    const c_gst_percentage = parseFloat(formData.c_gst) || 0;
    const s_gst_percentage = parseFloat(formData.s_gst) || 0;

    const total_c_gst = (parseFloat(total_price) * c_gst_percentage / 100).toFixed(2);
    const total_s_gst = (parseFloat(total_price) * s_gst_percentage / 100).toFixed(2);

    const total_amount = (parseFloat(total_price) + parseFloat(other_charges_total) + parseFloat(total_c_gst) + parseFloat(total_s_gst)).toFixed(2);
    const handleSubmitOrder = () => {

        let newErrors = {};

        const productsData = rows.flatMap(row =>
            row.component_order.map(fields => ({
                category_id: String(row.category_id),
                id: row?.id ?? null,
                order_id: order_Update_id,
                area_id: row.area_id,
                product_id: row.product_id ? String(row.product_id.id) : null,
                qty: row.qty,
                gst: row.gst,
                area_description: fields.area_description || '',
                sale_price: fields.sale_price || '',
                cost_price: fields.cost_price || '',
                price: fields.sale_price || "",
                area_description_id: fields.area_description_id,

            }))
        );

        // Process productsData
        productsData.forEach((product, index) => {
            if (productorderID[index] && productorderID[index].product_order_id !== undefined) {
                product.id = productorderID[index].product_order_id;
            }
        });

        // Process componentsData without enforcing uniqueness
        const componentsData = rows.flatMap(row =>
            row.component_order
                ?.map(field => {
                    console.warn("Component ID for field:", field.id);  // Log the field ID
                    return {
                        category_id: row.category_id,
                        id: field?.id ?? null,
                        vender_id: field.vender_id,
                        product_id: row.product_id ? row.product_id.id : null,
                        area: field.area,
                        area_id: row.area_id,
                        area_description_id: field.area_description_id,
                        area_description: field.area_description || '',
                        sale_price: field.sale_price || '',
                        cost_price: field.cost_price || '',
                        order_id: order_Update_id
                    };
                }) || []
        );
       
        console.warn("fgkfjkg", rows)
        const subComponentData = rows.flatMap(row =>
            row.component_order?.flatMap(field =>
                field.sub_component_order?.map(extra => ({
                    component_id: String(extra.component_id),
                    category_id: String(row.category_id),
                    product_id: row.product_id ? String(row.product_id.id) : null,
                    area_id: row.area_id,
                    vender_id: String(extra.vender_id),
                    area_description_id: field.area_description_id,
                    id: extra?.id ?? null,
                    order_id: order_Update_id
                })) || []
            ) || []
        );

        console.warn("Products Data:", productsData);
        console.warn("Final Components Data:", componentsData);
        console.warn("Subcomponents Data:", subComponentData);

        const OtherData = rowother
            .filter(row => row.tr_charge && row.lable_charge) // Only include valid rows
            .map(row => ({
                tr_charge: row.tr_charge,
                id: row.id,
                lable_charge: row.lable_charge,
                name: row.order_id,
            }));

        const ExtraData = rows1
            .filter(row => row.pro_qty && row.price && row.total_amount)
            .map(row => ({
                customer_id: data.id,
                category_id: row.category_id,
                vendor_id: row.vendor_id,
                name: row.name,
                id: row.id,
                pro_qty: row.pro_qty,
                price: row.price,
                total_amount: row.total_amount,
            }));

        const requestData = {
            ...formData,
            total_price,
            other_charges_total,
            total_c_gst,
            total_s_gst,
            total_amount,
            products: productsData,
            componentOrder: componentsData,
            subcomponentOrder: subComponentData,
            otherdata: OtherData.length > 0 ? OtherData : [],
            order_id: orderid,
            extra_products: ExtraData.length > 0 ? ExtraData : [],
            order_date: formData.order_date || new Date().toISOString().split('T')[0],
            account_mode: account_mode,
        };

        console.warn("formData", formData)
        // console.log('Final Payload:', requestData);

        console.warn('Request Payloadss:', {
            products: productsData,
            componentOrder: componentsData,
            subcomponentOrder: subComponentData,
        });

        let invalidDescriptions = []; // To hold all area_description values with missing vendor or component

    // Loop through the rows (assuming rows1 is your data structure)
    rows.forEach(row => {
        row.component_order.forEach(fieldData => {
            // Check if any sub-component is missing component or vendor_id
            fieldData.sub_component_order.forEach(extraField => {
                if (!extraField.component_id || !extraField.vender_id) {
                    // Capture the area_description if component or vendor is missing
                    invalidDescriptions.push(fieldData.area_description || 'Unknown description');
                }
            });
        });
    });

    // If there are any invalid descriptions, show an alert with all of them
    if (invalidDescriptions.length > 0) {
        Swal.fire({
            title: 'Warning',
            text: `Please select both vendor and component for the following descriptions:\n${invalidDescriptions.join('\n')}`,
            icon: 'warning',
            confirmButtonText: 'OK'
        });
        return; // Stop form submission
    }

        handleSubmit(
            `${process.env.REACT_APP_API_URL}Order-manufacture-update`,
            requestData,
            () => {
                // Success callback
            }
        );
        // } else {
        //     // Validation failed
        // }

    };

    // stock-Update APi
    const handleStockSubmit = async (url, formData, successCallback) => {
        setLoading(true);
        try {
            const response = await axios.post(url, formData, {
                headers: {
                    'Content-Type': 'application/json',
                    'x-access-token': token,
                },
            });
            if (successCallback) successCallback(response.data);
        } catch (error) {
            console.error("Error in handleStockSubmit:", error);
        } finally {
            setLoading(false);
        }
    };

    const filterSearchName = async (searchTerm) => {
        try {
            const response = await axios.post(`${process.env.REACT_APP_API_URL}Order-search-list`, { customer_name: searchTerm }, {
                headers: {
                    'Content-Type': 'application/json',
                    'x-access-token': token,
                },
            });

            if (response.data.status === 1) {
                setSearchNameList(response.data.data || []);
            } else {
                setSearchNameList([]);
            }
        } catch (error) {
            console.error('Error fetching search results:', error);
            setSearchNameList([]);
        }
    };
    const fetchCustomerDetails = async (id) => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}Order-search-customer-list/${id}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'x-access-token': token,
                },
            });

            const customerData = response.data.data[0];
            setFormData({
                order_date: customerData.order_date,
                customer_name: customerData.customer_name,
                customer_type: customerData.customer_type, // Assuming customer_type is fetched
                mobile_number: customerData.mobile_number,
                site_name: customerData.site_name,
                pincode: customerData.pincode,
                email: customerData.email,
                city: customerData.city,
                state: customerData.state,
                address1: customerData.address1,
                address2: customerData.address2,
                account_name: customerData.account_name,
                account_mode: customerData.account_mode,
                payer_name: customerData.payer_name,
                receiver_name: customerData.receiver_name,
            });
            setFilteredNameList([]);
        } catch (error) {
            console.error('Error fetching customer details:', error);
        }
    };
    useEffect(() => {
        const fetchCategories = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_URL}category-list`, {
                    headers: {
                        'Content-Type': 'application/json',
                        'x-access-token': token,
                    },
                });
                setCategories(response.data.data || []);
            } catch (error) {
                console.error('Error fetching categories:', error);
            }
        };
        if (!modalState.addproduct, rows) {
            fetchCategories();
            // setRows();        
        }
    }, [token, modalState.addproduct]);
    useEffect(() => {
        const fetchComponents = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_URL}component-list`, {
                    headers: {
                        'Content-Type': 'application/json',
                        'x-access-token': token,
                    },
                });
                setComponents(response.data.data || []);
            } catch (error) {
                console.error('Error fetching components:', error);
            }
        };
        if (!modalState.addproduct, rows) {
            fetchComponents();
            // setRows();        
        }
    }, [token, modalState.addproduct]);



    useEffect(() => {
        const fetchVendor = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_URL}Vender-list`, {
                    headers: {
                        'Content-Type': 'application/json',
                        'x-access-token': token,
                    },
                });
                setVenderlist(response.data.data || []);
            } catch (error) {
                console.error('Error fetching categories:', error);
            }
        };

        fetchVendor();
        // setRows();        

    }, [token]);

    useEffect(() => {


        if (!modalState.addproduct) {
            fetchProducts();
            // setRows();        
        }
    }, [modalState.addproduct, token,]);

    const fetchProducts = async () => {
        try {
            const url = `${process.env.REACT_APP_API_URL}Order-view-product-list/${order_Update_id}`;
            const config = {
                method: 'get',
                url: url,
                headers: {
                    'Content-Type': 'application/json',
                    'x-access-token': token,
                },
            };
            const response = await axios(config);
            const { createOrder, product, component_order, sub_component_order, extra_charges_store, product_other_data } = response.data.rows;
            // console.warn(product_other_data);

            const orderDetails = createOrder[0];

            // setAreaCount(response.data.rows.component_order ? response.data.rows.component_order.length : 0);
            // console.log("sssssssssssssss", AreaCount)


            // setTotalData(orderDetails);
            setViewData({
                ...orderDetails,
                products: product,
                componentOrder: component_order,
                subcomponentOrder: sub_component_order,
                extra_products: extra_charges_store,
                otherData: product_other_data || []
            });
            const customerData = orderDetails;
            console.warn(customerData)
            setFormData({
                customer_id: customerData.id,
                account_id: customerData.account_id,
                account_mode: customerData.account_mode,
                due_amt: customerData.due_amt,
                order_date: customerData.order_date,
                customer_name: customerData.customer_name,
                customer_type: customerData.customer_type,
                invoice_number_manual: customerData.invoice_number_manual,
                description: customerData.description,
                mobile_number: customerData.mobile_number,
                site_name: customerData.site_name,
                pincode: customerData.pincode,
                email: customerData.email,
                city: customerData.city,
                state: customerData.state,
                address1: customerData.address1,
                address2: customerData.address2,
                account_name: customerData.account_id,
                payer_name: customerData.payer_name,
                receiver_name: customerData.receiver_name,
                amount: customerData.amount,
                total_price: customerData.total_price,
                delivery_date: customerData.delivery_date,
                manufacture: orderDetails.manufacture,
                c_gst: orderDetails.c_gst,
                s_gst: orderDetails.s_gst,
                total_amount: orderDetails.total_amount,
                gst_in_no: orderDetails.gst_in_no,
                vehicle_number: orderDetails.vehicle_number,
                // order_id_id: orderDetails.product[0].order_id,
            });

            setTotalcustomerDataamount(customerData.amount)
            if (product.length > 0) {
                // Map product data
                let updatedRowsss = product.map(item => ({
                    product_order_id: item.product_order_id,
                }));
                const uniqueProductIds = new Set();

                // Map product data and ensure unique product IDs
                let updatedRows = product
                    .filter(item => {
                        // Check if product_id is already in the Set
                        if (uniqueProductIds.has(item.product_id)) {
                            return false; // Skip duplicates
                        }
                        uniqueProductIds.add(item.product_id);
                        return true; // Include unique items
                    })
                    .map(item => ({
                        id: item.product_order_id,
                        order_id: item.order_id,
                        vendor_id: item.vender_id,
                        category_id: item.category_id,
                        product_id: { id: item.product_id, name: item.name },
                        qty: item.qty,
                        qty_old: item.qty,
                        pro_qty: item.pro_qty,
                        price: item.price,
                        gst: item.gst,
                        manufacture: item.manufacture,
                        pro_unit: item.pro_unit,
                        hsn_no: item.hsn_no,
                        total_amount: item.total_amount,
                        sale_price: item.sale_price,
                        area_id: item.area_id,
                        component_order: [] // Placeholder for nested component_order
                    }));


                setproductorderID(updatedRowsss);
                // Include component_order data with same category_id
                if (component_order.length > 0) {
                    updatedRows = updatedRows.map(row => ({
                        ...row,
                        component_order: component_order
                            .filter(component => component.product_id === row.product_id.id) // Match category_id
                            .map(component => ({
                                id: component.id,
                                area_description: component.area_description,
                                area_id: Number(component.area_id),
                                cost_price: component.cost_price,
                                sale_price: component.sale_price,
                                category_id: component.category_id,
                                product_id: component.product_id,
                                area_description_id: component.area_description_id,
                                sub_component_order: [] // Placeholder for nested sub_component_order
                            }))
                    }));
                }
                console.warn("areacheckkksdasdk", updatedRows)

                if (sub_component_order && sub_component_order.length > 0) {

                    updatedRows = updatedRows.map(row => ({
                        ...row,
                        component_order: row.component_order.map(component => ({
                            ...component,
                            sub_component_order: sub_component_order.filter(subComponent =>
                                component.area_description_id == subComponent.area_description_id
                            ).map(subComponent => ({
                                id: subComponent.id,
                                area_des_id: component.id,
                                component_id: subComponent.component_id,
                                area_description_id: subComponent.area_description_id,
                                vender_id: subComponent.vender_id,
                                category_id: subComponent.category_id,
                                area_id: Number(subComponent.area_id),
                                component_name: subComponent.component_name,
                                vendor_name: subComponent.vendor_name
                            }))
                        }))
                    }));

                }



                setRows(updatedRows);
                console.warn("mithleh", updatedRows)
                if (updatedRows.length > 0) {
                    const { id, name } = updatedRows[0].product_id;
                    setEnterQtyStockId(id);
                    setEnterQtyStockName(name);
                    setEnterQtyStockpro_qty(updatedRows[0].qty);
                }
            }

            // if (product.length > 0) {
            //     const updatedRows = product.map(item => ({
            //         // category_id: { id: item.category_id, name: item.name },
            //         id: item.product_order_id,
            //         order_id: item.order_id,
            //         vendor_id: item.vender_id,
            //         category_id: item.category_id,
            //         product_id: { id: item.product_id, name: item.name },
            //         qty: item.qty,
            //         qty_old: item.qty,
            //         pro_qty: item.pro_qty,
            //         price: item.price,
            //         gst: item.gst,
            //         manufacture: item.manufacture,
            //         pro_unit: item.pro_unit,
            //         hsn_no: item.hsn_no,
            //         total_amount: item.total_amount,
            //         sale_price: item.sale_price,
            //         area_id: Number(item.area_id),
            //         component_order: [], // Placeholder for nested component_order

            //     }));
            //     console.log("updatedRowssssss", updatedRows);
            //     setRows(updatedRows);

            //     if (component_order.length > 0) {
            //         const updatedRows = component_order.map(item => ({
            //             id: item.id,
            //             area_description: item.area_description,
            //             cost_price: item.cost_price,
            //             sale_price: item.sale_price,
            //             category_id: item.category_id,
            //             product_id: item.product_id,
            //             sub_component_order: []
            //             // vendor_id: { id: item.vendor_id, vendor_name: item.vendor_name },
            //         }));
            //         setFields(updatedRows);
            //         console.warn("componentssss", updatedRows);
            //     }

            //     if (sub_component_order.length > 0) {
            //         const updatedRows = sub_component_order.map(item => ({
            //             id: item.id,
            //             component_id: item.component_id,
            //             vender_id: item.vender_id,
            //             category_id: item.category_id,
            //             area_id: item.area_id,
            //             component_name: item.component_name,
            //             vendor_name: item.vendor_name
            //         }));
            //         setFields1(updatedRows);
            //         console.warn("componentssss1", updatedRows);
            //     }

            //     if (updatedRows.length > 0) {
            //         const { id, name } = updatedRows[0].product_id;
            //         // const { qty } = updatedRows[0].qty;  
            //         setEnterQtyStockId(id);
            //         setEnterQtyStockName(name);
            //         setEnterQtyStockpro_qty(updatedRows[0].qty);
            //         console.warn("Old Qty", updatedRows[0].qty);
            //     }

            // }
            if (extra_charges_store.length > 0) {
                const updatedRows = extra_charges_store.map(item => ({
                    id: item.id,
                    order_id: item.order_id,
                    customer_id: item.customer_id,
                    category_id: item.category_id,
                    name: item.name,
                    pro_qty: item.pro_qty,
                    price: item.price,
                    total_amount: item.total_amount,
                    vendor_id: item.vendor_id,
                    // vendor_id: { id: item.vendor_id, vendor_name: item.vendor_name },

                }));
                setRows1(updatedRows);
            }
            if (product_other_data.length > 0) {
                const updatedRowsother = product_other_data && product_other_data.map(item => ({
                    tr_charge: item.tr_charge,
                    lable_charge: item.lable_charge,
                    id: item.id,
                    // name: item.name || '',
                }));
                setRowother(updatedRowsother);
            }
        } catch (error) {
            console.error('Error fetching products:', error);
        }
    };


    useEffect(() => {
        const fetchProducts1 = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_URL}product-vieworder`, {
                    headers: {
                        'Content-Type': 'application/json',
                        'x-access-token': token,
                    },
                });
                setproductorder(response.data.data || []);

                // setStockId(response.data.data);
            } catch (error) {
                console.error('Error fetching products:', error);
            }
        };

        if (!modalState.addraw || !modalState.addproduct) {
            fetchProducts1();
            // ProductView();
        }
    }, [modalState.addraw, modalState.addproduct, token]);

    const ProductView = async (id) => {
        setCurrentEditId(id);
        handleShowEditModal();
        try {
            let url = `${process.env.REACT_APP_API_URL}product-view/${id}`;
            const config = {
                method: 'get',
                url: url,
                headers: {
                    'Content-Type': 'application/json',
                    'x-access-token': token,
                },
            };
            const response = await axios(config);
            setViewdata(response.data.data || []);

        } catch (error) {
            console.error("There was a problem with the fetch operation:", error);
        }
    };
    useEffect(() => {
        fetchAccountList();
    }, []);

    const fetchAccountList = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}Account-list`, {
                headers: {
                    'Content-Type': 'application/json',
                    'x-access-token': token,
                },
            });
            setAccountList(response.data.data || []);
        } catch (error) {
            console.error('Error fetching employee list:', error);
        }
    };
    const handleDeleteProduct = (productId) => {
        const updatedProducts = productorderdata.filter(product => product.id !== productId);
        setproductorder(updatedProducts);

    };
    const accountModeOptions = [
        { value: 'Cash', label: 'Cash' },
        { value: 'Online', label: 'Online' },
        // { value: 'Either or Survivor Mode', label: 'Either or Survivor Mode' },
    ];

    const accountOptions = accountlist ? accountlist.map(employee => ({
        value: employee.id,
        label: employee.account_name,
        account_type: employee.account_type,
    })) : [];

    const handleDeleteRow = (index) => {
        const updatedRows = rows.filter((_, i) => i !== index);
        setRows(updatedRows);
    };
    const handleDeleteRowother = (index) => {
        const updatedRows = rowother.filter((_, i) => i !== index);
        setRowother(updatedRows);
    };
    const handleSearchItemClick = async (selectedName, customerId) => {
        setFormData({ ...formData, customer_name: selectedName });
        setSearchNameList([]);
        fetchCustomerDetails(customerId);
    };
    const goBack = () => {
        navigate('/orderview');
    };


    const orderTypeOptions = [
        { value: '', label: 'Select Order' },
        { value: 'invoice', label: 'Invoice' },
    ];

    const formatNumber = (num) => {
        return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    };

    // const handleFieldChange = (rowIndex, fieldIndex, fieldName, value) => {
    //     const updatedRows = [...rows];

    //     // Handle area_id change
    //     if (fieldName === 'area_id') {
    //         const previousAreaValue = updatedRows[rowIndex].area_id;
    //         updatedRows[rowIndex].area_id = value;

    //         // Ensure the area value is unique across all rows
    //         const areaExists = updatedRows.some((row, index) => row.area_id === value && index !== rowIndex);
    //         if (areaExists) {
    //             alert("This area ID already exists. Please enter a unique value.");
    //             return;
    //         }

    //         // Adjust component_order based on the area value increase/decrease
    //         if (value > previousAreaValue) {
    //             const newComponent = {
    //                 area_id: value,
    //                 area_description_id:uuidv4(),
    //                 area_description: '',
    //                 cost_price: '',
    //                 sale_price: '',
    //                 sub_component_order: [{ component_id: null, vender_id: null }],
    //             };

    //             const additionalFields = Array(value - previousAreaValue).fill(newComponent);
    //             updatedRows[rowIndex].component_order.push(...additionalFields);
    //         } else if (value < previousAreaValue) {
    //             const rowsToRemove = previousAreaValue - value;
    //             updatedRows[rowIndex].component_order.splice(-rowsToRemove);
    //         }
    //     }
    //     // Handle updates for other fields
    //     else if (fieldName === 'area_description' || fieldName === 'cost_price' || fieldName === 'sale_price') {
    //         const updatedComponentOrder = updatedRows[rowIndex].component_order.map((field, idx) => {
    //             if (idx === fieldIndex) {
    //                 return { ...field, [fieldName]: value };
    //             }
    //             return field;
    //         });
    //         updatedRows[rowIndex].component_order = updatedComponentOrder;
    //     }
    //     else if (fieldName === 'product_id') {
    //         updatedRows[rowIndex].product_id = value;  // Ensure each row has its own product_id
    //     } else {
    //         // Handle other fields like category_id, vendor_id, etc.
    //         if (fieldName === 'category_id') {
    //             updatedRows[rowIndex].category_id = value;
    //         }
    //     }

    //     setRows(updatedRows); // Update the rows in state
    // };


    const handleFieldChange = (rowIndex, fieldIndex, fieldName, value) => {
        const updatedRows = [...rows];

        // Handle area_id change
        // if (fieldName === 'area_id') {
        //     const previousAreaValue = updatedRows[rowIndex].area_id;
        //     updatedRows[rowIndex].area_id = value;

        //     if (value > previousAreaValue) {
        //         const newComponent = {
        //             area_id: value,
        //             area_description_id: uuidv4(),
        //             area_description: '',
        //             cost_price: '',
        //             sale_price: '',
        //             sub_component_order: [{ component_id: null, vender_id: null }],
        //         };

        //         const additionalFields = Array(value - previousAreaValue).fill(newComponent);
        //         updatedRows[rowIndex].component_order.push(...additionalFields);
        //     } else if (value < previousAreaValue) {
        //         const rowsToRemove = previousAreaValue - value;
        //         updatedRows[rowIndex].component_order.splice(-rowsToRemove);
        //     }
        // }
        if (fieldName === 'area_id') {
            const previousAreaValue = updatedRows[rowIndex].area_id;
            updatedRows[rowIndex].area_id = value;

            if (value > previousAreaValue) {
                const additionalFields = Array.from({ length: value - previousAreaValue }, () => ({
                    area_id: value,
                    area_description_id: uuidv4(),
                    area_description: '',
                    cost_price: '',
                    sale_price: '',
                    sub_component_order: [{ component_id: null, vender_id: null }],
                }));

                updatedRows[rowIndex].component_order.push(...additionalFields);
            } else if (value < previousAreaValue) {
                const rowsToRemove = previousAreaValue - value;
                updatedRows[rowIndex].component_order.splice(-rowsToRemove);
            }
        }
        // Handle updates for other fields
        else if (fieldName === 'area_description' || fieldName === 'cost_price' || fieldName === 'sale_price') {
            const updatedComponentOrder = updatedRows[rowIndex].component_order.map((field, idx) => {
                if (idx === fieldIndex) {
                    return { ...field, [fieldName]: value };
                }
                return field;
            });
            updatedRows[rowIndex].component_order = updatedComponentOrder;
        }
        else if (fieldName === 'product_id') {
            updatedRows[rowIndex].product_id = value;  // Ensure each row has its own product_id
        } else {
            // Handle other fields like category_id, vendor_id, etc.
            if (fieldName === 'category_id') {
                updatedRows[rowIndex].category_id = value;
            }
        }
        setRows(updatedRows); // Update the rows in state
    };
    console.warn("rowssssss", rows);

    const handleAddMore = (index) => {
        const updatedFields = [...fields];

        // Ensure that extraFields exists for the specific index
        if (!updatedFields[index].extraFields) {
            updatedFields[index].extraFields = []; // Initialize if undefined
        }

        // Add a new entry to extraFields
        updatedFields[index].extraFields.push({
            component: "",
            vendorName: "",
        });

        setFields(updatedFields);
    };

    const handleDelete = (index, subIndex) => {
        const updatedFields = [...fields];

        if (subIndex >= 0) {
            // Remove the extraField at the specified subIndex
            updatedFields[index].extraFields.splice(subIndex, 1);
        } else {
            // Handle main row deletion if necessary (e.g., removing the whole item at index)
            updatedFields.splice(index, 1);
        }

        setFields(updatedFields);
    };

    const OrderManufactureDeleteareaid = async (id, product_id) => {
        console.warn(product_id, id)
        try {
            const result = await Swal.fire({
                title: "Are you sure?",
                text: "Delete this Complete Area!!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes, delete it!",
            });
            if (result.isConfirmed) {
                let url = `${process.env.REACT_APP_API_URL}Order-Manufacture-delete_areaid/${id}?product_id=${product_id.id}`;
                const config = {
                    method: 'get',
                    url: url,
                    headers: {
                        'Content-Type': 'application/json',
                        'x-access-token': token,
                    },
                };
                const response = await axios(config);
                if (response.data.status === 1) {
                    toast.success(response.data.message);
                    fetchProducts();
                } else {
                    toast.error(response.data.message);
                }
            }
        } catch (error) {
            console.error("There was a problem with the fetch operation:", error);
        } finally {
            // setLoadinglist(false);
        }
    };
    const OrderManufactureDeleteAreaDescreptionId = async (id, area_description_id) => {

        try {
            const result = await Swal.fire({
                title: "Are you sure?",
                text: "Delete this Area Description!!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes, delete it!",
            });
            if (result.isConfirmed) {
                let url = `${process.env.REACT_APP_API_URL}Order-Manufacture-delete_area_description_id/${id}?area_description_id=${area_description_id}`;
                const config = {
                    method: 'get',
                    url: url,
                    headers: {
                        'Content-Type': 'application/json',
                        'x-access-token': token,
                    },
                };
                const response = await axios(config);
                if (response.data.status === 1) {
                    toast.success(response.data.message);
                    fetchProducts();
                } else {
                    toast.error(response.data.message);
                }
            }
        } catch (error) {
            console.error("There was a problem with the fetch operation:", error);
        } finally {
            // setLoadinglist(false);
        }
    };
    const OrderManufactureDeleteSubComponent = async (id, SubComponentid) => {

        try {
            const result = await Swal.fire({
                title: "Are you sure?",
                text: "Delete this Component and Vendor!!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes, delete it!",
            });
            if (result.isConfirmed) {
                let url = `${process.env.REACT_APP_API_URL}Order-Manufacture-delete_SubComponent_id/${id}?id=${SubComponentid}`;
                const config = {
                    method: 'get',
                    url: url,
                    headers: {
                        'Content-Type': 'application/json',
                        'x-access-token': token,
                    },
                };
                const response = await axios(config);
                if (response.data.status === 1) {
                    toast.success(response.data.message);
                    fetchProducts();
                } else {
                    toast.error(response.data.message);
                }
            }
        } catch (error) {
            console.error("There was a problem with the fetch operation:", error);
        } finally {
            // setLoadinglist(false);
        }
    };
    return (
        <section className="takeorder_section">
            <ToastContainer />
            <div className="page-header  d-flex justify-content-between">
                <div className="page-title">
                    {/* <h4>Order</h4> */}
                    <h4>Create Order Update</h4>
                </div>
                <Button type="button" className="btn-added" onClick={goBack}> <FaArrowLeftLong style={{ paddingRight: '3px' }} />  Back</Button>

            </div>
            <Card>
                <Card.Header className="d-flex justify-content-between align-items-center">
                    <Card.Title>Create Order Update</Card.Title>
                    {/* <Form>
                        <Form.Check
                            type="checkbox"
                            id="custom-switch"
                            label="GST"
                        />
                    </Form> */}
                </Card.Header>
                <Card.Body>
                    <div className="takeorder_heading">
                        <h4 className="mb-0">Customer Information</h4>
                    </div>
                    <Row>
                        {[
                            { label: "Date", name: "order_date", type: "date" },
                            { label: "Customer Type", name: "customer_type", type: "select", options: [{ value: "Retail", label: "Retail" }, { value: "Site", label: "Site" }, { value: "Design", label: "Design" }] },
                            { label: "Customer Name", name: "customer_name", type: "text" },
                            { label: "Mobile Number", name: "mobile_number", type: "text" },
                            { label: "Invoice Number", name: "invoice_number_manual", type: "number" },
                            { label: "Site Name", name: "site_name", type: "text" },
                            { label: "Pin Code", name: "pincode", type: "text" },
                            { label: "Email", name: "email", type: "email" },
                            { label: "City", name: "city", type: "text" },
                            { label: "State", name: "state", type: "text" },
                            { label: "Address One", name: "address1", type: "text" },
                            { label: "Address Two", name: "address2", type: "text" },
                        ].map(({ label, name, type, options }, idx) => (
                            <Col md={4} lg={4} key={idx}>
                                <Form.Group controlId={name} className='position-relative'>
                                    <Form.Label>{label}</Form.Label>
                                    {type === "select" ? (
                                        <Form.Select
                                            name={name}
                                            value={formData[name]}
                                            onChange={handleInputChange}
                                            isInvalid={!!errors[name]}
                                        >
                                            <option value="">Select {label}</option>
                                            {options.map((option) => (
                                                <option key={option.value} value={option.value}>{option.label}</option>
                                            ))}
                                        </Form.Select>
                                    ) : (
                                        <Form.Control
                                            type={type}
                                            name={name}
                                            placeholder={`Enter ${label}`}
                                            value={formData[name] || (name === "order_date" ? new Date().toISOString().split('T')[0] : '')}
                                            onChange={handleInputChange}
                                            isInvalid={!!errors[name]}
                                            onFocus={name === "order_date" ? (e) => e.target.showPicker() : null}
                                        />
                                    )}
                                    {name === "customer_name" && searchNameList.length > 0 && (
                                        <div className="search-results">

                                            {searchNameList.map((item, index) => (
                                                <div key={index} className="search-item" onClick={() => handleSearchItemClick(item.customer_name, item.id)}>
                                                    {item.customer_name}
                                                </div>
                                            ))}

                                        </div>
                                    )}

                                </Form.Group>
                            </Col>
                        ))}
                        <Col md={6} xs={12} lg={6}>
                            <Form.Group className="mb-3">
                                <Form.Label>Description</Form.Label>
                                <Form.Control
                                    as="textarea"
                                    name="description"
                                    placeholder="Description"
                                    value={formData.description}
                                    onChange={handleInputChange}
                                // isInvalid={!!errors.amount}
                                />
                            </Form.Group>
                        </Col>
                        {/* <Col md={6} lg={6} xs={12}>
                            <Form.Group >
                                <Form.Label>Select Bill Type</Form.Label>
                                <Select options={orderTypeOptions}
                                    defaultValue={orderTypeOptions[0]}
                                    onChange={handleOrderTypeChange}
                                />

                            </Form.Group>
                        </Col> */}
                    </Row>
                    {selectedOrderType.value === 'invoice' && (
                        <Row>

                            <Col md={2} xs={2} lg={2}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Invoice Number</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="invoice_number_manual"
                                        placeholder="Invoice Number"
                                        value={formData.invoice_number_manual}
                                        onChange={handleInputChange}
                                    // isInvalid={!!errors.amount}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={2} xs={2} lg={2}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Vehicle Number</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="vehicle_number"
                                        placeholder="Vehicle Number"
                                        value={formData.vehicle_number}
                                        onChange={handleInputChange}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={2} xs={2} lg={2}>
                                <Form.Group className="mb-3">
                                    <Form.Label>GSTIN No</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="gst_in_no"
                                        placeholder="GSTIN No"
                                        value={formData.gst_in_no}
                                        onChange={handleInputChange}
                                    />
                                </Form.Group>
                            </Col>
                            {/* <Col md={2} xs={2} lg={2}>
                                <Form.Group className="mb-3">
                                    <Form.Label>CGST </Form.Label>
                                    <Form.Control
                                        type="number"
                                        name="c_gst"
                                        placeholder="CGST "
                                        value={formData.c_gst}
                                        onChange={handleInputChange}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={2} xs={2} lg={2}>
                                <Form.Group className="mb-3">
                                    <Form.Label>SGST </Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="s_gst"
                                        placeholder="SGST "
                                        value={formData.s_gst}
                                        onChange={handleInputChange}
                                    />
                                </Form.Group>
                            </Col> */}
                        </Row>
                    )}
                </Card.Body>
            </Card>
            <Card>
                <Card.Header className="d-flex justify-content-between align-items-center">
                    <Card.Title>Select Product</Card.Title>
                    <Button onClick={() => setModalState({ ...modalState, addproduct: true })} className="btn-added addproduct">
                        <MdAddCircle /> Create Product
                    </Button>
                </Card.Header>
                <Card.Body>
                    <Row>
                        <Col md={12} xs={12} lg={12}>
                            <label><strong>Manufacture Type</strong></label>
                            <div className="d-flex justify-content-between">
                                <div className="d-flex gap-2 align-items-center">
                                    {/* <Form.Check
                                        type="radio"
                                        label="Trading"
                                        name="manufacture"
                                        id="product_type_trading"
                                        value="Trading"
                                        onChange={handleInputChange}
                                        checked={formData.manufacture === 'Trading'}
                                    /> */}
                                    <Form.Check
                                        type="radio"
                                        label="Manufacture"
                                        name="manufacture"
                                        id="product_type_manufacture"
                                        value="Manufacture"
                                        onChange={handleInputChange}
                                        checked={formData.manufacture === 'Manufacture'}
                                    />
                                </div>
                                <Button onClick={handleAddRow} className="btn-added addproduct">
                                    <MdAddCircle /> Add More
                                </Button>
                            </div>
                        </Col>

                    </Row>
                    {rows.map((row1, rowIndex) => (
                        <Row key={rowIndex} className="mt-3">
                            {/* Product Category */}

                            <Col xs={12} md={4} lg={2}>
                                <Form.Group className="mb-3" controlId={`category_id_${rowIndex}`}>
                                    <Form.Label>Product Category</Form.Label>
                                    <Select
                                        value={categoryOptions.find(option => option.value == row1.category_id)}
                                        options={categoryOptions}
                                        isSearchable={true}
                                        placeholder="Select"
                                        onChange={(selected) => handleRowChange(rowIndex, 'category_id', selected ? selected.value : null)}
                                    />
                                </Form.Group>
                            </Col>

                            {/* Product Name */}
                            <Col xs={12} md={4} lg={3}>
                                <Form.Group className="mb-3" controlId={`product_name_${rowIndex}`}>
                                    <Form.Label>Product Name</Form.Label>
                                    <Select
                                        options={getProductOptionsForRow(row1.category_id, formData.manufacture)}
                                        value={row1.product_id ? { value: row1.product_id.id, label: row1.product_id.name, cost_price: row1.product_id.man_amount, sale_price: row1.product_id.sale_man_amount } : null}
                                        isSearchable={true}
                                        placeholder="Select"
                                        onChange={(selected) => handleFieldChange(rowIndex, null, 'product_id', selected ? { id: selected.value, name: selected.label } : null)}
                                    />
                                </Form.Group>
                            </Col>

                            {/* Area */}
                            <Col xs={12} md={4} lg={2}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Area</Form.Label>
                                    {(row1.category_id && row1.component_order.length >= 1) ?

                                        <Form.Control
                                            type="number"
                                            name="area_id"
                                            value={row1.component_order.length}
                                            placeholder="Enter number of Area"
                                            onChange={(e) => handleFieldChange(rowIndex, null, 'area_id', e.target.value)}
                                            disabled

                                        />
                                        :
                                        <Form.Control
                                            type="number"
                                            name="area_id"
                                            value={row1.area_id}
                                            placeholder="Enter number of Area"
                                            onChange={(e) => handleFieldChange(rowIndex, null, 'area_id', e.target.value)}


                                        />
                                    }
                                </Form.Group>
                            </Col>



                            {/* Delete Row */}
                            <Col md={1} xs={12} lg={1} className="d-flex align-items-center">
                                <button className="btn-added" onClick={() => {

                                    if (row1.product_id === undefined || row1.product_id === null) {
                                        handleDeleteRow(rowIndex);
                                    } else {

                                        OrderManufactureDeleteareaid(order_Update_id, row1.product_id);
                                    }
                                }}>
                                    <FiMinusCircle />
                                </button>
                            </Col>
                            <Col md={1} xs={12} lg={1} className="d-flex align-items-center">
                            {row1.id != null ? 
                                <button className="btn-added" onClick={() => handleCheckButtonClickold(rowIndex)}>
                                   <MdAddCircle /> All 
                                </button>
                                :
                                <button className="btn-added" onClick={() => handleCheckButtonClicknew(rowIndex)}>
                                    <MdAddCircle /> All 
                                </button>
                                }
                            </Col>
                            {/* Fields for Description, Cost Price, Sale Price */}
                            {row1.component_order.map((field, fieldIndex) => (
                                <React.Fragment key={fieldIndex}>
                                    <Row className="mb-3">
                                        <Col xs={12} md={2}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Description</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    value={field.area_description || ''}
                                                    onChange={(e) => handleFieldChange(rowIndex, fieldIndex, 'area_description', e.target.value)}
                                                />
                                            </Form.Group>
                                        </Col>

                                        <Col xs={12} md={2}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Cost Price</Form.Label>
                                                <Form.Control
                                                    type="number"
                                                    value={field.cost_price || ''}
                                                    onChange={(e) => handleFieldChange(rowIndex, fieldIndex, "cost_price", e.target.value)}
                                                />
                                            </Form.Group>
                                        </Col>

                                        <Col xs={12} md={2}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Sale Price</Form.Label>
                                                <Form.Control
                                                    type="number"
                                                    value={field.sale_price || ''}
                                                    onChange={(e) => handleFieldChange(rowIndex, fieldIndex, "sale_price", e.target.value)}
                                                />
                                            </Form.Group>
                                        </Col>

                                        {/* Add More Component and Vendor */}
                                        <Col xs={3} md={1}>
                                            <Button
                                                variant="primary"
                                                onClick={() => {

                                                    OrderManufactureDeleteAreaDescreptionId(order_Update_id, field.area_description_id);
                                                }}
                                                className="mt-4 me-2"
                                            >
                                                <FiMinusCircle />
                                            </Button>
                                            <Button
                                                variant="primary"
                                                onClick={() => handleAddMoreComponentVendor(rowIndex, fieldIndex)}
                                                className="mt-4"
                                            >
                                                <MdAddCircle />
                                            </Button>

                                        </Col>

                                        {/* Extra Fields: Component and Vendor */}
                                        <Col xs={6} md={5}>
                                            <Row>
                                                {field.sub_component_order.map((extraField, extraFieldIndex) => (
                                                    <React.Fragment key={extraFieldIndex}>
                                                        <Col xs={12} md={6}>
                                                            <Form.Group className="mb-2">
                                                                <Form.Label>Component</Form.Label>
                                                                <Select
                                                                    value={componentOptions.find(option => option.value == extraField.component_id) || null}
                                                                    options={componentOptions}
                                                                    isSearchable
                                                                    placeholder="Select Component"
                                                                    onChange={selected => handleComponentSelection(rowIndex, fieldIndex, extraFieldIndex, selected)}
                                                                />
                                                            </Form.Group>
                                                        </Col>

                                                        <Col xs={12} md={6}>
                                                            <Form.Group className="mb-2" controlId={`vendor_id_${rowIndex}_${extraFieldIndex}`}>
                                                                <Form.Label>Vendor Name</Form.Label>
                                                                <Select
                                                                    value={vendorOptions.find(option => option.value == extraField.vender_id) || null}
                                                                    options={vendorOptions}
                                                                    isSearchable
                                                                    placeholder="Select Vendor"
                                                                    onChange={selected => handleVendorSelection(rowIndex, fieldIndex, extraFieldIndex, selected)}
                                                                />
                                                            </Form.Group>
                                                        </Col>

                                                        <Col xs={12} className="d-flex justify-content-end">
                                                            <Button variant="primary"
                                                                onClick={() => {


                                                                    // Only call the API if extraField.id is undefined or null
                                                                    if (extraField.id === undefined || extraField.id === null) {

                                                                        handleDeleteExtraField(rowIndex, fieldIndex, extraFieldIndex);
                                                                    }
                                                                    else {
                                                                        OrderManufactureDeleteSubComponent(order_Update_id, extraField.id);
                                                                    }
                                                                }}
                                                            >
                                                                <FiMinusCircle />
                                                            </Button>

                                                        </Col>
                                                    </React.Fragment>
                                                ))}
                                            </Row>
                                        </Col>

                                    </Row>
                                </React.Fragment>
                            ))}
                        </Row>
                    ))}

                </Card.Body>
            </Card>
            {/* {rows.some(row => row.product_id) ? (
                <Card className='mt-2'>
                    <Card.Header className="d-flex justify-content-between align-items-center">
                        <Card.Title>Product Details</Card.Title>
                    </Card.Header>
                    <Card.Body>
                        <div className="table-responsive">
                            <Table striped bordered hover>
                                <thead>
                                    <tr className="thead-dark">
                                        <th>Sr No</th>
                                        <th>Product Name</th>
                                        <th>Cost Price</th>
                                        <th>Sale Price</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {productorderdata && productorderdata.length > 0 ? (
                                        productorderdata
                                            .filter(item => rows.some(row => row.product_id && row.product_id.id == item.id))
                                            .map((item, index) => (
                                                <tr key={item.id}>
                                                    <td>{index + 1}</td>
                                                    <td>{item.name}</td>
                                                    <td>{item.man_amount}</td>
                                                    <td>{item.sale_man_amount}</td>
                                                </tr>
                                            ))
                                    ) : (
                                        <tr>
                                            <td colSpan="7" className='text-center'>
                                                <span>Select Product Name</span>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </Table>
                        </div>
                    </Card.Body>
                </Card>
            ) : null} */}


            <Card>
                <Card.Header className="d-flex justify-content-between align-items-center">
                    <Card.Title>Other Charges</Card.Title>
                    {/* <Button onClick={handleAddRowOther} className="btn-added addproduct">
                        <MdAddCircle /> Add More
                    </Button> */}
                </Card.Header>
                <Card.Body>
                    {rowother.map((row, index) => (
                        <Row key={index} className="mt-3">
                            <Col md={2} xs={12} lg={3}>
                                <Form.Group className="mb-3" controlId={`price_${index}`}>
                                    {/* <Form.Label></Form.Label> */}
                                    <Form.Control
                                        type="text"
                                        name="tr_charge"
                                        placeholder="Name"
                                        value={row.tr_charge}
                                        onChange={(e) => handleRowChangeOther(index, 'tr_charge', e.target.value)}
                                    />
                                </Form.Group>
                            </Col>


                            <Col md={2} xs={12} lg={4}>
                                <Form.Group className="mb-3" controlId={`price_${index}`}>
                                    {/* <Form.Label></Form.Label> */}
                                    <Form.Control
                                        type="text"
                                        name="lable_charge"
                                        placeholder="Value"
                                        value={row.lable_charge}
                                        onChange={(e) => handleRowChangeOther(index, 'lable_charge', e.target.value)}
                                    />
                                </Form.Group>
                            </Col>
                            {/* <Col md={2} xs={12} lg={4}>
                                <Form.Group className="mb-3" controlId={`price_${index}`}>
                                    <Form.Label>Name</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="name"
                                        placeholder="Name"
                                        value={row.name}
                                        onChange={(e) => handleRowChangeOther(index, 'name', e.target.value)}
                                    />
                                </Form.Group>
                            </Col> */}
                            <Col md={1} xs={12} lg={1} className='d-flex align-items-center'>
                                <button
                                    className='btn-added'
                                    onClick={() => handleDeleteRowother(index)}
                                >
                                    <RiDeleteBin6Line />
                                </button>
                            </Col>

                        </Row>
                    ))}

                </Card.Body>
            </Card>


            {/* <Button>Extra Charges Add</Button> */}
            <Card>
                <Card.Body>
                    <Row>
                        <>
                            {data.order_type === 'invoice' ? (
                                <>
                                    <Col md={2} xs={2} lg={2}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>CGST %</Form.Label>
                                            <Form.Control
                                                type="number"
                                                name="c_gst"
                                                placeholder="CGST %"
                                                value={formData.c_gst}
                                                onChange={handleInputChange}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={2} xs={2} lg={2}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>SGST %</Form.Label>
                                            <Form.Control
                                                type="number" // should be 'number' if it’s a percentage input
                                                name="s_gst"
                                                placeholder="SGST %"
                                                value={formData.s_gst}
                                                onChange={handleInputChange}
                                            />
                                        </Form.Group>
                                    </Col>
                                </>
                            ) : null}
                            <Col md={2} lg={2} col={12}>
                                <Form.Label>Total price</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="total_price"
                                    placeholder="Enter Total Price"
                                    disabled
                                    // value={(rows.reduce((total, row) => {
                                    //     // Ensure row.price, row.gst, row.qty are valid numbers
                                    //     const price = parseFloat(row.price) || 0;
                                    //     const gst = parseFloat(row.gst) || 0;
                                    //     const qty = parseFloat(row.qty) || 0;

                                    //     // Calculate price with GST
                                    //     const priceWithGst = price * (1 + gst / 100);

                                    //     // Return the accumulated total, adding price for this row
                                    //     return total + (qty * priceWithGst);
                                    // }, 0) + parseFloat(extra_charges_total || 0)).toFixed(2)}  // Adding extra_charges_total
                                    value={new Intl.NumberFormat().format(total_price)}
                                    readOnly
                                    onChange={handleInputChange}
                                />
                            </Col>


                            {selectedOrderType.value === 'invoice' && (
                                <Col md={2} xs={2} lg={2}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Cgst </Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="total_c_gst"
                                            placeholder="CGST "
                                            disabled
                                            value={total_c_gst}
                                            readOnly
                                            onChange={handleInputChange}
                                        />
                                    </Form.Group>
                                </Col>
                            )}
                            {selectedOrderType.value === 'invoice' && (
                                <Col md={2} xs={2} lg={2}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Sgst </Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="total_s_gst"
                                            placeholder="SGST "
                                            disabled
                                            value={total_s_gst}
                                            readOnly
                                            onChange={handleInputChange}
                                        />
                                    </Form.Group>
                                </Col>
                            )}
                            <Col md={2} lg={2} col={12}>
                                <Form.Label>Total Amount</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="total_price"
                                    placeholder="Enter Total Price"
                                    disabled
                                    value={new Intl.NumberFormat().format(total_amount)}
                                    readOnly
                                />
                            </Col>

                            <Col md={3} lg={3} col={12}>
                                <Form.Group controlId="delivery_date">
                                    <Form.Label>Delivery Date</Form.Label>
                                    <Form.Control
                                        type="date"
                                        name="delivery_date"
                                        placeholder="Delivery Date"
                                        value={formData.delivery_date}
                                        onChange={handleInputChange}
                                        isInvalid={!!errors.delivery_date}
                                        onFocus={(e) => e.target.showPicker()}
                                    />

                                </Form.Group>
                            </Col>
                        </>
                    </Row>
                </Card.Body>
            </Card>
            <Card>
                <Card.Header className="d-flex justify-content-between align-items-center">
                    <Card.Title>Account</Card.Title>

                </Card.Header>
                <Card.Body>
                    <Row>
                        <Col md={4} lg={4} col={12}>
                            <Form.Group controlId="amount">
                                <Form.Label>Enter Amount</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="amount"
                                    placeholder="Enter Amount"
                                    value={formData.amount}
                                    onChange={handleInputChange}
                                    isInvalid={!!errors.amount}
                                />
                            </Form.Group>

                        </Col>
                        <Col md={4} lg={4} xs={12}>
                            <Form.Group controlId="account_name">
                                <Form.Label>Select Account</Form.Label>
                                <Select
                                    value={accountOptions && accountOptions.find(option => option.value == formData.account_id)}
                                    onChange={(selected) => handleSelectChange('account_id', selected)}
                                    options={accountOptions}
                                />
                            </Form.Group>
                        </Col>

                        <Col md={4} lg={4} xs={12}>
                            <Form.Group controlId="account_mode">
                                <Form.Label>Account Mode</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="account_mode"
                                    placeholder="Account Mode"
                                    value={formData.account_mode || ''}
                                    disabled
                                />
                            </Form.Group>
                        </Col>
                        {/* 
                        <Col md={4} lg={4} col={12}>
                            <Form.Group controlId="account_mode">
                                <Form.Label>Select Mode</Form.Label>
                                <Select
                                    value={accountModeOptions.find(option => option.value == formData.account_mode)}
                                    onChange={(selected) => handleSelectChange('account_mode', selected)}
                                    options={accountModeOptions}

                                />
                            </Form.Group>
                        </Col> */}

                        <Col md={4} lg={4} col={12}>
                            <Form.Group controlId="receiver_name">
                                <Form.Label>Receiver Name</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="receiver_name"
                                    placeholder="Receiver Name"
                                    value={formData.receiver_name}
                                    onChange={handleInputChange}
                                    isInvalid={!!errors.receiver_name}
                                />

                            </Form.Group>
                        </Col>
                        <Col md={4} lg={4} col={12}>
                            <Form.Group controlId="payer_name">
                                <Form.Label>Payer Name</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="payer_name"
                                    placeholder="Payer Name"
                                    value={formData.payer_name}
                                    onChange={handleInputChange}
                                    isInvalid={!!errors.payer_name}
                                />

                            </Form.Group>
                        </Col>
                    </Row>
                </Card.Body>
            </Card>

            <div className="d-flex justify-content-end">
                <div className="d-flex gap-1">
                    <Button className="btn takeorder" disabled={loading} onClick={handleSubmitOrder} >
                        {loading ? 'Saving...' : 'Create Order Update'}
                    </Button>
                </div>
            </div>
            <Modal
                size="xl"
                show={modalState.addproduct}
                onHide={() => setModalState({ ...modalState, addproduct: false })}
                aria-labelledby="example-modal-sizes-title-lg"
            >
                <Modal.Header closeButton>
                    <h3 className="card-title mb-0">Add Product</h3>
                </Modal.Header>

                <Modal.Body closeButton>
                    <Addproduct onSave={() => setModalState({ ...modalState, addproduct: false })} />
                </Modal.Body>
            </Modal>
            <Modal
                size="lg"
                show={modalState.addraw}
                onHide={() => setModalState({ ...modalState, addraw: false })}
                aria-labelledby="example-modal-sizes-title-lg"
            >

                <Modal.Body closeButton>
                    <AddproductRaw onSave={() => setModalState({ ...modalState, addraw: false })} />
                </Modal.Body>
            </Modal>
            {/* <Modal show={showEditModal} size="lg" onHide={handleCloseEditModal}>
                <Modal.Header closeButton>
                    <Modal.Title><h4>View Details</h4></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="table-responsive">
                       
                        <table className="table">
                            <tbody>
                                {viewdata.map((item) => (
                                    <React.Fragment key={item.id}>


                                        <tr>
                                            <td colSpan="6">
                                                <h6 className="fw-bold">Row Materials</h6>
                                                <table className="table">
                                                    <thead className='thead-primary'>
                                                        <tr>
                                                      
                                                            <th>Name</th>
                                                            <th>Qty</th>
                                                            <th>Unit Cost Price</th>
                                                            <th>Unit Sale Price</th>
                                                            <th>Cost Price</th>
                                                            <th>Sale Price</th>
                                                            <th>Vendor Name</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {item.row_materials.map(material => (
                                                            <tr key={material.id}>
                                                          
                                                                <td>{material.raw_name}</td>
                                                             
                                                                <td>{material.qty}</td>
                                                                <td>{material.u_cost_prize}</td>
                                                                <td>{material.unit_sale_price}</td>
                                                                <td>{material.Costprice}</td>
                                                                <td>{material.Saleprice}</td>
                                                                <td>{material.vender_Name}</td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colSpan="6">
                                                <h6 className="fw-bold">Attributes</h6>
                                                <table className="table">
                                                    <thead className='thead-info'>
                                                        <tr>
                                                            <th>Id</th>
                                                            <th>Name</th>
                                                            <th>Value</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {item.attributes.map(attr => (
                                                            <tr key={attr.id}>
                                                                <td>{attr.id}</td>
                                                                <td>{attr.name}</td>
                                                                <td>{attr.value}</td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </td>
                                        </tr>
                                    </React.Fragment>
                                ))}
                            </tbody>
                        </table>
                    </div>

                </Modal.Body>

            </Modal> */}
        </section >
    );
}
